import { render } from "./PathSelectionScreen.vue?vue&type=template&id=155b8942"
import script from "./PathSelectionScreen.vue?vue&type=script&lang=js"
export * from "./PathSelectionScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__